import api from '../adapter/base'
export const restore=(url,id)=>{
    return api.post(`${url}/${id}/restore`)
}